<template>
  <NovaRequisicaoMaterialComponent
    :category="2"
    :title="'Requisição Material Uniformes'"
  />
</template>

<script>
import NovaRequisicaoMaterialComponent from "../components/NovaRequisicaoMaterialComponent.vue";
export default {
  components: {
    NovaRequisicaoMaterialComponent,
  },
};
</script>

<style></style>
